export function queryObject(object) {
    return `?${Object.keys(object)
        .filter((key) => typeof object[key] !== 'undefined')
        .map((key) => `${key}=${encodeURIComponent(object[key])}`)
        .join('&')}`;
}
